
import { Component, Prop, Vue } from "vue-property-decorator";
import axios from "axios";
import router from "@/router";
import { cacheSrv } from "./../services/cache";
import store from "./../store";
import HeaderRewards from './common/HeaderRewards.vue'
import { notiSrv } from "./../services/noti";

@Component({components:{HeaderRewards}})
export default class Signin extends Vue {

  OTP_SUPPORT = false
  strongRegex = new RegExp(
    "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
  );
  mediumRegex = new RegExp(
    "^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})"
  );
  passwordStrength = { "background-color": "red" };

  personal_info = true
  authAPIUrl = this.$store.getters.config.authAPIUrl;
  CACHE_KEY_TOKEN = this.$store.getters.tokenKeys.CACHE_KEY_TOKEN;
  CACHE_KEY_PROFILE = this.$store.getters.tokenKeys.CACHE_KEY_PROFILE;
  user = {
    username: "",
    mobileNo: "",
    password: "",
    repeat_password: "",
    name: "",
    email: "",
    otp: "",
    tnc: false
  };
  submitted = false;
  processing = false;
  errorMessage = "";
  username;
  otpRequested = false;
  rerequestOTP = false
  requestingOTP = false;
  mismatchPass = false;

  constructor() {
    super();
  }
  created() {
     window.scrollTo(0,0);
    console.log("Login created", this.$route.query.username);
    this.username = this.$route.query["username"];
    if(!this.username){
      notiSrv.sayNoti("Start by entering your personal valid mobile number", 5000)
      router.push("login");
    }
    this.user.mobileNo = this.username;
    this.user.username = this.username;
    let token = store.state.token;
    if (token) {
      router.push("profile");
    } else {
      //this.disableMenu();
    }
  }

  disableMenu() {
    //store.commit("disableMenu", true);
  }

  stengthPass() {
    let value = this.user.password;
    console.log("Check pass strength :", value);
    if (this.strongRegex.test(value)) {
      this.passwordStrength["background-color"] = "green";
    } else if (this.mediumRegex.test(value)) {
      this.passwordStrength["background-color"] = "orange";
    } else {
      this.passwordStrength["background-color"] = "red";
    }
    this.checkMismatch();
  }
  checkMismatch() {
    if (this.user.password && this.user.repeat_password) {
      if (this.user.repeat_password != this.user.password) {
        this.mismatchPass = true;
      } else {
        this.mismatchPass = false;
      }
    } else {
    }
    console.log("checkMismatch", this.mismatchPass);
  }

  nextStep(){
    if(this.OTP_SUPPORT){
      this.personal_info=false;
    }
    else{
      this.register()
    }

  }

  async requestOtp() {
    this.processing = true;
    this.requestingOTP = true
    console.log("requestOtp ", this.user.username);
    try {
      let result = await axios.post(`${this.authAPIUrl}request-otp`, {
        mobileNo: this.user.mobileNo
      });
      this.processing = false;
      if (result.data) {
        let data = result.data;
        console.log("data", data);
        if (data["error"]) {
          console.log("Error in validating number");
          this.errorMessage = "Error requesting OTP";
          this.requestingOTP = false;
          return;
        }
        if (data["success"]) {
          this.user.otp = "";
          this.otpRequested = true;
          console.log("OTP Request OK. Pending SMS delivery");
          this.errorMessage = "";
          this.requestingOTP = false;
          
          setTimeout(()=>{
            this.rerequestOTP = true
          },1000*20)
          return;
        }
      } else {
        console.log("Error in registering user . No data");
        this.requestingOTP = false;
      }
    } catch (e) {
      console.log("Error in obtaining OTP.", e);
      this.errorMessage = "Error in obtaining OTP. Please try again";
      this.requestingOTP = false;
    }
  }

  async register() {
    this.processing = true;
    if (
      this.user.tnc==true && 
      this.user.name &&
      this.user.email &&
      this.user.mobileNo &&
      this.user.password &&
      this.user.repeat_password &&
      this.user.password == this.user.repeat_password &&
      ((this.user.otp && this.otpRequested)||!this.OTP_SUPPORT)
    ) {
      try {
        let result = await axios.post(`${this.authAPIUrl}register`, this.user);
        if (result.data) {
          let data = result.data;
          console.log("data", data);
          if (data["error"]) {
            console.log("Error in validating number");
            this.errorMessage = data["meta"].original.error.message;
            return;
          }
          if (data["user"]) {
            //console.log("TODO TODO. Add option to immediatelly retrieve Membership Card Number and assoicate it with the ")

            console.log("storing user");
            this.errorMessage = "";
            cacheSrv.cacheEx(
              this.CACHE_KEY_PROFILE,
              data["user"],
              60 * 60 * 24 * 360
            ); //slighly less then a year
            store.commit(`updateUser`, data["user"]);
            if (data["token"]) {
              cacheSrv.cacheEx(
                this.CACHE_KEY_TOKEN,
                data["token"],
                60 * 60 * 24 * 360
              ); //slighly less then a year
              store.commit(`updateToken`, data["token"]);
              setTimeout(function(){
                router.push("quiz");
              },1000)
            } else {
              //no token on register. Requires new login
              router.push("login");
            }
          } else {
            //router.push('register')
            //this.loginError = data['meta'].original.message
            console.log("no user on registration");
            this.processing = false;
          }
        } else {
          console.log("Error in registering user . No data");
          this.processing = false;
        }
      } catch (error) {
        this.processing = false;
        console.log("Error while registering. ", error.response);
        var errorData = error.response.data;
        if (errorData.code) {
          if (errorData.code == "FAILED_REGISTER") {
            this.errorMessage =
              "Error while registering. " + errorData.meta.error.message;
          } else if (errorData.code == "INVALID_OTP") {
            this.errorMessage =
              "Error in OTP Validation. Please check your OTP number and try again";
          }
        } else {
          this.errorMessage =
            "Error while registering. Please check your OTP number and try again";
        }
      }
    } else {
      console.log("Error. Form invalid");
      if (this.user.password != this.user.repeat_password) {
        this.errorMessage = "Passwords do not match";
      } else {
        this.errorMessage = "Please complete the form";
      }
      this.processing = false;
    }
  }
}
